import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import { Modal } from 'antd';
import './messageSubmit.css';
import PropTypes from 'prop-types';

import asReviewWpaFormConfim from '../../public/img/std/asReviewWpaFormConfim.png'
import cancelImg from '../../public/img/newMain/cancel.png';

/**
 * 消息提示组件
 * props传参如下
 * 消息提示类型,样式 ['error','success','warning','info']
 *                              error:错误提示框，红色样式
 *                              success:成功提示框，绿色样式
 *                              warning:警告提示框，黄色样式
 *                              info:普通提示框，蓝色样式
 */
let MessageSubmit = (props, ref) => {

    const [content, setContent] = useState("");
    const [isShow, setIsShow] = useState(false);
    useImperativeHandle(ref, () => {
        return {
            setContent,
            setIsShow,
        }
    });

    /**
     * 标题默认值处理
     */
    useEffect(() => {

    }, []);

    const save = () => {
        props.done(true);
    }

    const cancel = () => {
        props.done(false);
    }

    return (
        <Modal
            open={isShow}
            onCancel={null}
            closeIcon={null}
            footer={null}
            className='messageSubmit'
            width={720}
            centered
            closable={false}
        >
            <div className='contentBox'>
                <div>{content}</div>
                <div>Do you wish to submit?</div>
            </div>
            <div className='butArea'>
                <div className='saveButton' onClick={save}><img src={asReviewWpaFormConfim} />Yes</div>
                <div className='cancelButton' onClick={cancel}><img src={cancelImg} />No</div>
            </div>

        </Modal>
    )

}

MessageSubmit = forwardRef(MessageSubmit);

MessageSubmit.propTypes = {
    done: PropTypes.func.isRequired,
};

export default MessageSubmit;